import { render, staticRenderFns } from "./KulTourSection.vue?vue&type=template&id=2c7a9083&scoped=true"
import script from "./KulTourSection.vue?vue&type=script&lang=js"
export * from "./KulTourSection.vue?vue&type=script&lang=js"
import style0 from "./KulTourSection.vue?vue&type=style&index=0&id=2c7a9083&prod&lang=scss&scoped=true"
import style1 from "./KulTourSection.vue?vue&type=style&index=1&id=2c7a9083&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7a9083",
  null
  
)

export default component.exports